// src/components/chat/messages/UserMessage.tsx
import { jsx } from "react/jsx-runtime";
var UserMessage = (props) => {
  return /* @__PURE__ */ jsx("div", { className: "copilotKitMessage copilotKitUserMessage", children: props.subComponent || props.message });
};

export {
  UserMessage
};
//# sourceMappingURL=chunk-HWMFMBJC.mjs.map